<template>
  <v-container grid-list-md class="pa-0 ma-0">
    <v-layout row wrap>
      <v-flex xs12>
        <v-tabs v-model="tab"
        flat color="primary" dark
        grow height="40"
        fixed-tabs
        >
        <v-tab v-for="(tabItem, n) in tabItems" :key="n" :href="`#tab-${n}`">
          <v-badge overlap>
            <template v-slot:badge v-if="enabledFilter['tab-' + n]">
              <v-icon class="caption">filter_list</v-icon>
            </template>
            <div class="pa-2">{{ tabItem + ' (' + (tabItem === 'All Open' ? openTickets.length : closedTickets.length) + ')'}}</div>
          </v-badge>
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab" v-if="lAction === 'view'">
        <v-tab-item v-for="(tabItem, n) in tabItems" :key="n" :value="`tab-${n}`">
          <!-- card view -->
          <v-flex xs12 sm7 mx-auto v-if="choosenView === 'card'">
            <v-card flat>
              <v-card-text class="pt-3">
                <v-data-iterator
                :items="tabItem === 'All Open' ? openTickets : closedTickets"
                hide-actions>
                <template v-slot:item="props">
                  <v-layout>
                    <v-flex xs12 class="pb-2">
                      <v-card class="grey lighten-4">
                        <v-card-text class="py-0">
                          <v-layout row wrap>
                            <v-flex xs10 sm11>
                              <div class="pt-3 subheading">
                                <b>{{ '#' + props.item.ticket_id + ' - ' + props.item.dept_name + ' - ' + props.item.cat}}</b>
                              </div>
                            </v-flex>
                            <v-flex xs2 sm1 class="pa-0">
                              <v-menu bottom right class="mt-2" :close-on-content-click="false">
                                <span slot="activator">
                                  <v-btn small icon slot="activator" class="ma-0">
                                    <v-icon>more_vert</v-icon>
                                  </v-btn>
                                </span>
                                <v-list>
                                  <v-list-group
                                  no-action
                                  v-model="lSupport.status"
                                  >
                                  <template v-slot:activator>
                                    <v-list-tile>
                                      <v-list-tile-avatar><v-icon>track_changes</v-icon></v-list-tile-avatar>
                                      <v-list-tile-title>Change Status</v-list-tile-title>
                                    </v-list-tile>
                                  </template>
                                  <v-list-tile
                                  v-if="((tabItem === 'All Open') && props.item.status !== status && status !== 'Reopen') || (tabItem === 'All Closed' && props.item.status !== status && status === 'Reopen')"
                                  v-for="(status, i) in statusList"
                                  :key="i"
                                  @click="prepareTicketStatus(props.item, status)"
                                  >
                                  <v-list-tile-title>
                                    {{ status }}
                                  </v-list-tile-title>
                                </v-list-tile>
                              </v-list-group>
                              <v-list-tile v-if="props.item.status !== 'Completed' && props.item.status !== 'Cancelled'" @click="prepareTicketStatus(props.item, 'Comment')">
                                <v-list-tile-avatar><v-icon>comment</v-icon></v-list-tile-avatar>
                                <v-list-tile-title>Comment</v-list-tile-title>
                              </v-list-tile>
                              <v-list-tile @click="prepareUpdate(props.item)">
                                <v-list-tile-avatar><v-icon>edit</v-icon></v-list-tile-avatar>
                                <v-list-tile-title>Update</v-list-tile-title>
                              </v-list-tile>
                              <v-list-tile v-if="props.item.status === 'New' && props.item.assigned_to_name === null" @click="deleteTicket(props.item)">
                                <v-list-tile-avatar><v-icon>delete</v-icon></v-list-tile-avatar>
                                <v-list-tile-title>Delete</v-list-tile-title>
                              </v-list-tile>
                              <v-list-tile @click="loadTimeLine(props.item.ticket_id)">
                                <v-list-tile-avatar><v-icon>timeline</v-icon></v-list-tile-avatar>
                                <v-list-tile-title>Timeline</v-list-tile-title>
                              </v-list-tile>
                            </v-list>
                          </v-menu>
                        </v-flex>
                        <v-flex xs12>
                          <div class="pb-2">
                            {{ props.item.description.substring(0,150) + '...' }}
                          </div>
                          <v-divider></v-divider>
                        </v-flex>
                        <v-flex xs12>
                          <v-layout row wrap>
                            <v-flex xs6>
                              <v-layout row wrap>
                                <v-flex xs3 sm2>
                                  <v-avatar size="24px" slot="activator" class="pt-0">
                                    <img :src="config.STATIC_FILES_DIR + props.item.created_avatar_url"/>
                                  </v-avatar>
                                </v-flex>
                                <v-flex xs9 sm10 class="caption">
                                  <div class="primary--text"><strong>Created by</strong></div>
                                  <div>{{ props.item.created_by_name }}</div>
                                  <div>{{ handy.formatDate(props.item.created_dt) + ' ' + handy.getTime12Hrs(props.item.created_dt) }}</div>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6>
                              <v-layout row wrap>
                                <v-flex xs3 sm2>
                                  <v-avatar size="24px" slot="activator" class="pt-0">
                                    <img v-if="props.item.assigned_to" :src="config.STATIC_FILES_DIR + props.item.assigned_avatar_url"/>
                                    <v-icon class="grey" v-else>person</v-icon>
                                  </v-avatar>
                                </v-flex>
                                <v-flex xs9 sm10 class="caption">
                                  <div class="primary--text"><strong>Assigned to</strong></div>
                                  <div v-if="props.item.assigned_to">
                                    <div>{{ props.item.assigned_to_name }}</div>
                                    <div v-if="props.item.assigned_dt">{{ handy.formatDate(props.item.assigned_dt) + ' ' + handy.getTime12Hrs(props.item.assigned_dt) }}</div>
                                  </div>
                                  <div v-else>NA</div>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 class="subheading">
                              <v-divider class="pt-1"></v-divider>
                              <v-layout row wrap>
                                <v-flex xs5 style="font-size: 14px">
                                  <div class="pa-1" :class="props.item.status === 'New' ? 'grey--text' : (props.item.status === 'In Progress' ? 'accent--text' : (props.item.status === 'Completed' ? 'success--text' : 'error--text'))">
                                    <span class="primary--text"> Status: </span> <span style="font-weight: bold"> {{ props.item.status }} </span>
                                  </div>
                                </v-flex>
                                <v-flex xs5 style="font-size: 14px">
                                  <div class="pa-1">
                                    <span class="primary--text"> Priority: </span> <span class="green--text" style="font-weight: bold"> {{ props.item.priority }} </span>
                                  </div>
                                </v-flex>
                                <v-flex xs2 class="pa-1" v-if="props.item.tot_files" @click="loadTimeLine(props.item.ticket_id)">
                                  <v-badge overlap color="info">
                                    <template v-slot:badge>
                                      <span class="caption">{{ props.item.tot_files }}</span>
                                    </template>
                                    <v-icon small class="pa-2">attach_file</v-icon>
                                  </v-badge>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </template>
          </v-data-iterator>
        </v-card-text>
      </v-card>
    </v-flex>

    <!-- List view -->
    <v-flex xs12 mx-auto v-if="choosenView === 'list'">
      <v-card flat>
        <v-card-text>
          <v-data-table
          :headers="ticketHead"
          :items="tabItem === 'All Open' ? openTickets : closedTickets"
          disable-initial-sort
          hide-actions
          class="elevation-1"
          >
          <template slot="items" slot-scope="props">
            <tr>
              <td class="pa-2">{{ props.item.ticket_id }}</td>
              <td class="pa-2">{{ handy.formatDate(props.item.created_dt) }}</td>
              <td class="pa-2">{{ props.item.dept_name }}</td>
              <td class="pa-2">{{ props.item.cat }}</td>
              <td class="pa-2">{{ props.item.description.substring(0,150) + '...' }}</td>
              <td class="pa-2">{{ props.item.created_by_name }}</td>
              <td class="pa-2">{{ props.item.assigned_to ? props.item.assigned_to_name : 'NA' }}</td>
              <td class="pa-2">{{ props.item.priority }}</td>
              <td :class="'pa-2 ' + (props.item.status === 'New' ? 'grey--text' : (props.item.status === 'In Progress' ? 'accent--text' : (props.item.status === 'Completed' ? 'success--text' : 'error--text')))">{{ props.item.status }}</td>
              <td @click="loadTimeLine(props.item.ticket_id)">
                <v-badge overlap color="info" v-if="props.item.tot_files">
                  <template v-slot:badge>
                    <span class="caption"><strong>{{ props.item.tot_files }}</strong></span>
                  </template>
                  <v-icon small class="pa-2">attach_file</v-icon>
                </v-badge>
              </td>
              <td class="pa-2">
                <v-menu top right :close-on-content-click="false" class="mt-2">
                  <span slot="activator">
                    <v-btn small icon slot="activator">
                      <v-icon>more_vert</v-icon>
                    </v-btn>
                  </span>
                  <v-list>
                    <v-list-group
                    no-action
                    v-model="lSupport.status"
                    >
                    <template v-slot:activator>
                      <v-list-tile>
                        <v-list-tile-avatar><v-icon>track_changes</v-icon></v-list-tile-avatar>
                        <v-list-tile-title>Change Status</v-list-tile-title>
                      </v-list-tile>
                    </template>
                    <v-list-tile
                    v-if="((tabItem === 'All Open') && props.item.status !== status && status !== 'Reopen') || (tabItem === 'All Closed' && props.item.status !== status && status === 'Reopen')"
                    v-for="(status, i) in statusList"
                    :key="i"
                    @click="prepareTicketStatus(props.item, status)"
                    >
                    <v-list-tile-title>
                      {{ status }}
                    </v-list-tile-title>
                  </v-list-tile>
                </v-list-group>
                <v-list-tile v-if="props.item.status !== 'Completed' && props.item.status !== 'Cancelled'" @click="prepareTicketStatus(props.item, 'Comment')">
                  <v-list-tile-avatar><v-icon>comment</v-icon></v-list-tile-avatar>
                  <v-list-tile-title>Comment</v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="prepareUpdate(props.item)">
                  <v-list-tile-avatar><v-icon>edit</v-icon></v-list-tile-avatar>
                  <v-list-tile-title>Update</v-list-tile-title>
                </v-list-tile>
                <v-list-tile v-if="props.item.status === 'New' && props.item.assigned_to_name === null" @click="deleteTicket(props.item)">
                  <v-list-tile-avatar><v-icon>delete</v-icon></v-list-tile-avatar>
                  <v-list-tile-title>Delete</v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="loadTimeLine(props.item.ticket_id)">
                  <v-list-tile-avatar><v-icon>timeline</v-icon></v-list-tile-avatar>
                  <v-list-tile-title>Timeline</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-card-text>
</v-card>
</v-flex>
</v-tab-item>
<v-speed-dial :direction="$vuetify.breakpoint.smAndDown ? 'bottom' : 'left'" v-model="calFab"
style="position:fixed; top:90px; right:10px;">
<v-btn small slot="activator" v-model="calFab" fab color="accent">
  <v-icon>remove_red_eye</v-icon>
  <v-icon>close</v-icon>
</v-btn>
<!-- card view -->
<v-tooltip top>
  <template v-slot:activator="{ on }">
    <v-btn class="mr-1" fab small v-on="on"
    :color="choosenView === 'card' ? 'info' : ''"
    @click.native="changeView('card')">
    <v-icon>filter_frames</v-icon>
  </v-btn>
</template>
<span>Card view</span>
</v-tooltip>
<!-- List view -->
<v-tooltip top>
  <template v-slot:activator="{ on }">
    <v-btn class="ma-1" fab small v-on="on"
    :color="choosenView === 'list' ? 'info' : ''"
    @click.native="changeView('list')">
    <v-icon>list</v-icon>
  </v-btn>
</template>
<span>List view</span>
</v-tooltip>

</v-speed-dial>

</v-tabs-items>
</v-flex>

<!-- create and update support -->
<v-container grid-list-md v-if="lAction === 'Create' || lAction === 'Update'">
  <v-layout row wrap>
    <v-flex xs12>
      <v-form ref="sForm" @submit.prevent="saveTicket(lAction)">
        <v-card flat>
          <v-flex xs12 sm8 mx-auto>
            <v-card-title class="title pa-0 ml-3">
              {{ handy.startWithUpper(lAction) + ' Request' }}
            </v-card-title>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs6>
                  <v-select
                  v-model="lSupport.dep_pair"
                  :items="departmentList"
                  label="Department"
                  item-value="dept_id"
                  item-text="dept_name"
                  :rules="[rules.required]"
                  hide-details
                  return-object
                  @input="loadCategories(lSupport.dep_pair)"
                  ></v-select>
                </v-flex>
                <v-flex xs6>
                  <v-select
                  v-model="lSupport.cat_pair"
                  label="Category"
                  :items="catList"
                  item-value="cat_id"
                  item-text="cat"
                  :rules="[rules.required]"
                  hide-details
                  return-object
                  @input="loadSubCatList(lSupport.cat_pair)"
                  ></v-select>
                </v-flex>
                <v-flex xs6>
                  <v-select
                  v-model="lSupport.sub_cat_pair"
                  label="Sub Category"
                  :items="subCatList"
                  item-value="sub_cat_id"
                  item-text="sub_cat"
                  return-object
                  hide-details
                  @input="loadSubCatList(lSupport.sub_cat_pair)"
                  ></v-select>
                </v-flex>
                <v-flex xs6 v-if="lSupport.sub_cat_pair.sub_cat === 'Others'">
                  <v-text-field
                  v-model="lSupport.others"
                  label="Others"
                  hide-details
                  maxlength="50"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-layout row wrap>
                    <!-- enable assign to only for Uniservice Community (comm_id is 126) !-->
                    <v-flex xs4>
                      <v-select
                      v-model="lSupport.assigned_to_pair"
                      :items="assignUserList"
                      label="Assigned to"
                      item-text="emp_name_with_id"
                      item-value="emp_id"
                      hide-details
                      return-object
                      :disabled="lSupport.comm_id != 126"
                      ></v-select>
                    </v-flex>
                    <v-flex xs4>
                      <v-select
                      v-model="lSupport.priority_pair"
                      :items="priorityList"
                      label="Priority"
                      item-text="priority"
                      item-value="priority_id"
                      return-object
                      :rules="[rules.required]"
                      hide-details
                      :disabled="lSupport.status === 'Completed' || lSupport.status === 'Cancelled'"
                      ></v-select>
                    </v-flex>
                    <v-flex xs4>
                      <v-select
                      v-model="lSupport.status"
                      :items="['New', 'In Progress', 'On-Hold', 'Need More Info.', 'Job-Done', 'Completed', 'Cancelled', 'Reopen']"
                      label="Status"
                      hide-details
                      :disabled="lAction === 'Create' || lAction === 'Update'"
                      ></v-select>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 class="pt-2">
                  <v-textarea
                  v-model="lSupport.description"
                  label="Description"
                  rows="2"
                  :rules="[rules.required]"
                  hide-details
                  maxlength="3000"
                  box
                  ></v-textarea>
                </v-flex>
                <v-flex xs6>
                  <v-dialog ref="planStartDt"
                  persistent v-model="planStartDt"
                  lazy max-width="290px"
                  :return-value.sync="lSupport.planned_start_dt"
                  >
                  <v-text-field
                  slot="activator" label="Planned Start Date"
                  v-model="lSupport.planned_start_dt"
                  :rules="[rules.required]"
                  append-icon="event"
                  readonly clearable
                  hide-details
                  required
                  ></v-text-field>
                  <v-date-picker v-model="lSupport.planned_start_dt" scrollable
                  first-day-of-week="1"
                  >
                  <v-spacer></v-spacer>
                  <v-btn flat @click="planStartDt = false">Cancel</v-btn>
                  <v-btn flat color="accent" @click="$refs.planStartDt.save(lSupport.planned_start_dt)">OK</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-flex>
            <v-flex xs6>
              <v-dialog ref="planEndDt"
              persistent v-model="planEndDt"
              lazy max-width="290px"
              :return-value.sync="lSupport.planned_end_dt"
              >
              <v-text-field
              slot="activator" label="Planned End Date"
              v-model="lSupport.planned_end_dt"
              append-icon="event"
              readonly clearable
              hide-details
              required
              ></v-text-field>
              <v-date-picker v-model="lSupport.planned_end_dt" scrollable
              :min="lSupport.planned_start_dt" first-day-of-week="1"
              >
              <v-spacer></v-spacer>
              <v-btn flat @click="planEndDt = false">Cancel</v-btn>
              <v-btn flat color="accent" @click="$refs.planEndDt.save(lSupport.planned_end_dt)">OK</v-btn>
            </v-date-picker>
          </v-dialog>
        </v-flex>
        <v-flex xs4>
          <v-dialog ref="actStartDt"
          persistent v-model="actStartDt"
          lazy max-width="290px"
          :return-value.sync="lSupport.act_start_dt"
          >
          <v-text-field
          slot="activator" label="Actual Start Date"
          v-model="lSupport.act_start_dt"
          append-icon="event"
          disabled
          readonly clearable
          hide-details
          required
          ></v-text-field>
          <v-date-picker v-model="lSupport.act_start_dt" scrollable
          first-day-of-week="1"
          >
          <v-spacer></v-spacer>
          <v-btn flat @click="actStartDt = false">Cancel</v-btn>
          <v-btn flat color="accent" @click="$refs.actStartDt.save(lSupport.act_start_dt)">OK</v-btn>
        </v-date-picker>
      </v-dialog>
    </v-flex>
    <v-flex xs4>
      <v-dialog ref="actEndDt"
      persistent v-model="actEndDt"
      lazy max-width="290px"
      :return-value.sync="lSupport.act_end_dt"
      >
      <v-text-field
      slot="activator" label="Actual End Date"
      v-model="lSupport.act_end_dt"
      disabled
      append-icon="event"
      readonly clearable
      hide-details
      required
      ></v-text-field>
      <v-date-picker v-model="lSupport.act_end_dt" scrollable
      first-day-of-week="1"
      >
      <v-spacer></v-spacer>
      <v-btn flat @click="actEndDt = false">Cancel</v-btn>
      <v-btn flat color="accent" @click="$refs.actEndDt.save(lSupport.act_end_dt)">OK</v-btn>
    </v-date-picker>
  </v-dialog>
</v-flex>
<v-flex xs4>
  <v-dialog ref="jobDoneDt"
  persistent v-model="jobDoneDt"
  lazy max-width="290px"
  :return-value.sync="lSupport.job_done_dt"
  >
  <v-text-field
  slot="activator" label="Job Done Date"
  v-model="lSupport.job_done_dt"
  append-icon="event"
  disabled
  readonly clearable
  hide-details
  required
  ></v-text-field>
  <v-date-picker v-model="lSupport.job_done_dt" scrollable
  first-day-of-week="1" disabled
  >
  <v-spacer></v-spacer>
  <v-btn flat @click="jobDoneDt = false">Cancel</v-btn>
  <v-btn flat color="accent" @click="$refs.jobDoneDt.save(lSupport.job_done_dt)">OK</v-btn>
</v-date-picker>
</v-dialog>
</v-flex>
<v-flex xs12>
  <input style="display:none" type="file" ref="fileInput"
  accept=".xls, .xlsx, .pdf, .doc, .docx, image/png, image/gif, image/jpeg" multiple @change="loadFilesFromFileBrowser(lSupport)"/>
  <v-btn @click="pickFile" icon><v-icon>attach_file</v-icon></v-btn>
  <span v-if="lSupport.files && lSupport.files.filter(rec => rec.is_selected).length > 0">
    <span v-for="(file, index) in lSupport.files.filter(rec => rec.is_selected)" :key="index">
      <v-chip v-model="file.is_selected" @input="$forceUpdate()" close>
        <span v-if="!file.is_changed">
          <a :href="config.STATIC_FILES_DIR + file.file_url" download style="text-decoration: none;">
            <v-btn small icon class="ml-0 info lighten-1 grey--text text--lighten-4">
              <v-icon small>file_download</v-icon>
            </v-btn>
          </a>
        </span>
        <span class="ml-0">{{ file.file_name }}</span>
      </v-chip>
    </span>
  </span>
  <span v-else class="caption">Attachment if any (upto 20MB)</span>
</v-flex>
</v-layout>
</v-card-text>
<v-card-actions class="pt-3">
  <v-layout row wrap>
    <v-spacer></v-spacer>
    <v-btn @click.stop="cancelChanges">Cancel</v-btn>
    <v-btn type="submit" color="accent" :disabled="beingSaved || lSupport.status === 'Completed' || lSupport.status === 'Cancelled'">Save</v-btn>
  </v-layout>
</v-card-actions>
</v-flex>
</v-card>
</v-form>
</v-flex>
</v-layout>
</v-container>

<!-- 2. Give notes based on your actions(comment, need more info., on-hold, completed) -->
<v-dialog v-model="showDlgStatus" persistent max-width="500px">
  <v-card>
    <v-card-title class="pa-2 title">
      {{ 'Add comments for ' + lTicketStatus.action }}
    </v-card-title>
    <v-card-text class="black--text">
      <v-flex xs12 class="pt-2 pl-3" v-if="lTicketStatus.action === 'Completed'">
        <v-layout row wrap>
          <v-flex xs7 sm5>
            <v-dialog ref="dlgEndDate"
            persistent v-model="dlgEndDate"
            max-width="290px"
            :return-value.sync="lTicketStatus.planned_end_dt"
            >
            <template v-slot:activator="{ on }">
              <v-text-field
              slot="activator" label="Completed date"
              v-model="lTicketStatus.planned_end_dt"
              append-icon="mdi-calendar-today"
              readonly clearable
              hide-details
              :rules="[rules.required]"
              v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="lTicketStatus.planned_end_dt" scrollable
            :max="today" first-day-of-week="1"
            >
            <v-spacer></v-spacer>
            <v-btn text @click="dlgEndDate = false">Cancel</v-btn>
            <v-btn text color="accent" @click="$refs.dlgEndDate.save(lTicketStatus.planned_end_dt)">OK</v-btn>
          </v-date-picker>
        </v-dialog>
      </v-flex>
    </v-layout>
  </v-flex>
  <v-flex xs12>
    <v-textarea hide-details outline
    :placeholder="placeHolder"
    maxlength="250"
    v-model="lTicketStatus.notes"></v-textarea>
  </v-flex>
  <v-flex xs12 v-if="lTicketStatus.action === 'Comment'">
    <input style="display:none" type="file" ref="statusFileInput"
    accept=".xls, .xlsx, .pdf, .doc, .docx, image/png, image/gif, image/jpeg" multiple @change="loadFilesFromBrowser(lTicketStatus)"/>
    <v-btn icon @click="pickFile"><v-icon>attach_file</v-icon></v-btn>
    <span v-if="lTicketStatus.files && lTicketStatus.files.filter(rec => rec.is_selected).length > 0">
      <span v-for="(file, index) in lTicketStatus.files.filter(rec => rec.is_selected)" :key="index">
        <v-chip v-model="file.is_selected" @input="$forceUpdate()" close>
          {{ file.file_name }}
          <span v-if="!file.is_changed">
            <a :href="handy.loadImg(file.file_url, true)" download style="text-decoration: none;">
              <v-btn small icon class="ml-1 info grey--text text--lighten-4">
                <v-icon small>file_download</v-icon>
              </v-btn>
            </a>
          </span>
        </v-chip>
      </span>
    </span>
    <span v-else>Attachment(images, pdf, doc, word, excel) if any</span>
  </v-flex>
</v-card-text>
<v-card-actions>
  <v-spacer></v-spacer>
  <v-btn flat @click.stop="showDlgStatus = false">cancel</v-btn>
  <v-btn flat color="accent" @click="postTicketStatus()">submit</v-btn>
</v-card-actions>
</v-card>
</v-dialog>

<!-- 3. show Timeline for particular ticket_id -->
<v-dialog v-model="showTimeline" scrollable max-width="600px">
  <v-card>
    <v-card-title class="py-1 title info lighten-1">
      <div>Timeline</div>
      <v-spacer></v-spacer>
      <v-btn small icon @click.stop="showTimeline = false"><v-icon>close</v-icon></v-btn>
    </v-card-title>
    <v-card-text class="pl-0 pr-4 py-3">
      <v-timeline dense class="pt-0">
        <v-timeline-item :class="n === lTimeLine.length-1 ? 'pb-0' : ''"
        v-for="(timeline, n) in lTimeLine"
        :key="n"
        small
        :id="'timeline_' + n"
        >
        <template v-slot:icon>
          <v-avatar>
            <img :src="config.STATIC_FILES_DIR + timeline.avatar_url">
          </v-avatar>
        </template>
        <v-card class="grey lighten-4">
          <div v-if="timeline.action === 'Ticket Updated'">
            <v-card-title class="title pa-2">
              {{ timeline.action }}
            </v-card-title>
            <v-card-text class="pt-0 pb-2">
              <div v-if="timeline.notes !== ''">
                <div v-if="timeline.action === 'Ticket Updated'">
                  <div class="pb-1" v-if="timeline.assign_comments !== ''">
                    <b v-if="timeline.assign_comments !== ''">Assignee Comments: </b>{{ timeline.assign_comments }}
                  </div>
                  <div><b>Notes: </b>
                    <div v-for="(note, i) in timeline.timeLineNote" :key="i">
                      <span v-if="note">{{ i+1 + '. ' + note }}</span>
                    </div>
                  </div>
                </div>
                <div v-else class="pb-1">
                  <b>Notes: </b>{{ timeline.notes }}
                </div>
              </div>
              <div v-else>
                <div v-if="timeline.is_updated_by_sv_user === false"><b>Assigned to: </b>{{ timeline.assigned_to_name }}</div>
                <div class="pb-1" v-if="timeline.assign_comments !== ''">
                  <b v-if="timeline.assign_comments !== ''">Assignee Comments: </b>{{ timeline.assign_comments }}
                </div>
              </div>
            </v-card-text>
          </div>
          <div v-else>
            <v-card-title class="title pa-2">
              {{ timeline.action }}
            </v-card-title>
            <v-card-text class="pt-0 pb-2">
              <div v-if="timeline.action === 'Assigned' || timeline.is_updated_by_sv_user === false"><b>Assigned to: </b> {{timeline.assigned_to_name }}</div>
              <div v-if="timeline.action === 'Ticket Created'"><b>Description: </b>{{ timeline.notes }}</div>
              <div v-else><b>Comments: </b>{{ timeline.notes }}</div>
            </v-card-text>
          </div>
          <v-container grid-list-sm class="pa-0" v-if="lTimeLine.attachImages && lTimeLine.attachImages.filter(rec => rec.action === timeline.action && timeline.ticket_det_id === rec.ticket_det_id).length ||
          lTimeLine.attachFile && lTimeLine.attachFile.filter(rec => rec.action === timeline.action && timeline.ticket_det_id === rec.ticket_det_id)">
          <v-layout row wrap>
            <v-flex xs12 sm10 v-if="lTimeLine.attachImages.length && lTimeLine.attachImages.filter(rec => rec.action === timeline.action).length > 0">
              <v-flex xs12 v-if="(lTimeLine.attachImages.filter(rec => rec.action === timeline.action && rec.ticket_det_id === timeline.ticket_det_id).length > 0) && (lTimeLine.attachFile.filter(rec => rec.action === timeline.action && rec.ticket_det_id === timeline.ticket_det_id).length > 0)">
                <v-layout row wrap class="caption grey--text mb-2">
                  <v-flex xs6 sm8 class="ml-1">
                    Image Attachments
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12>
                <div v-viewer="options" class="clearfix">
                  <template v-for="(file, index) in lTimeLine.attachImages">
                    <span v-if="(file.action === timeline.action && file.ticket_det_id === timeline.ticket_det_id)">
                      <img width="80px" :src="config.STATIC_FILES_DIR + file.file_url" :data-source="config.STATIC_FILES_DIR + file.file_url" :key="index" class="ma-1" style="display: inline-block; cursor: pointer;">
                    </span>
                  </template>
                </div>
              </v-flex>
            </v-flex>
            <v-flex xs12 sm10 v-if="lTimeLine.attachFile.length && lTimeLine.attachFile.filter(rec => rec.action === timeline.action).length > 0">
              <v-flex xs12 v-if="(lTimeLine.attachImages.filter(rec => rec.action === timeline.action && rec.ticket_det_id === timeline.ticket_det_id).length > 0) && (lTimeLine.attachFile.filter(rec => rec.action === timeline.action && rec.ticket_det_id === timeline.ticket_det_id).length > 0)">
                <v-layout row wrap class="caption grey--text mb-2">
                  <v-flex xs6 sm8 class="ml-1">
                    Other Attachments
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12>
                <span v-for="(file, index) in lTimeLine.attachFile" :key="index">
                  <v-chip v-if="(file.action === timeline.action && file.ticket_det_id === timeline.ticket_det_id)">
                    <a :href="config.STATIC_FILES_DIR + file.file_url" download style="text-decoration: none;">
                      <v-btn small icon class="ml-0 pa-0 info lighten-1 grey--text text--lighten-4">
                        <v-icon small>file_download</v-icon>
                      </v-btn>
                    </a>
                    {{file.file_name}}
                  </v-chip>
                </span>
              </v-flex>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-container>
      <v-divider></v-divider>
      <v-card-actions class="caption pa-2">
        {{ timeline.created_by_name }}
        <span class="grey--text pl-2">{{ handy.formatDate(timeline.action_dt) + ' ' + handy.getTime12Hrs(timeline.action_dt) }}</span>
      </v-card-actions>
    </v-card>
  </v-timeline-item>
</v-timeline>
</v-card-text>
</v-card>
</v-dialog>

<!-- 4. show filter category in bottom sheet -->
<v-bottom-sheet inset class="caption" v-model="showFilter" max-width="500px">
  <v-card>
    <v-card-text>
      <v-container grid-list-md class="pa-0">
        <v-layout row wrap>
          <v-flex xs12>
            <div class="caption primary--text">Filter by attributes</div>
          </v-flex>
          <v-flex xs6>
            <v-select
            v-model="filterListByTab[tab].ticket_dept_list"
            :items="departmentList"
            label="Department"
            item-text="dept_name"
            item-value="dept_id"
            small-chips
            clearable
            dense
            hide-details
            return-object
            @input="loadCategories(filterListByTab[tab].ticket_dept_list)"
            ></v-select>
          </v-flex>
          <v-flex xs6>
            <v-select
            v-model="filterListByTab[tab].ticket_cat_list"
            :items="catList"
            label="Category"
            item-text="cat"
            item-value="cat_id"
            hide-details
            small-chips
            clearable
            dense
            multiple
            ></v-select>
          </v-flex>
          <v-flex xs6>
            <v-select
            v-model="filterListByTab[tab].priority_list"
            label="Priority"
            :items="priorityList"
            item-text="priority"
            item-value="priority_id"
            small-chips
            clearable
            dense
            multiple
            hide-details
            ></v-select>
          </v-flex>
          <v-flex xs6>
            <v-select
            v-model="filterListByTab[tab].ticket_status_list"
            label="Status"
            :items="filterStatus"
            small-chips
            clearable
            dense
            multiple
            hide-details
            ></v-select>
          </v-flex>
          <v-flex xs12>
            <div class="caption primary--text pt-3">Filter by people</div>
          </v-flex>
          <v-flex xs12>
            <v-select
            v-model="filterListByTab[tab].created_user_pair_list"
            label="Created by"
            :items="mcList"
            item-text="user_name"
            dense
            hide-details
            return-object
            ></v-select>
          </v-flex>
          <v-flex xs12>
            <v-select
            v-model="filterListByTab[tab].assigned_user_pair_list"
            :items="assignUserList"
            label="Assigned to"
            item-text="emp_name_with_id"
            dense
            hide-details
            return-object
            ></v-select>
          </v-flex>
          <v-flex xs12>
            <div class="caption primary--text pt-3">Filter by date</div>
          </v-flex>
          <v-flex xs6>
            <v-dialog ref="dlgFromDate"
            persistent v-model="dlgFromDate"
            lazy max-width="290px"
            :return-value.sync="filterListByTab[tab].from_dt"
            >
            <v-text-field
            slot="activator" label="Due from"
            v-model="filterListByTab[tab].from_dt"
            append-icon="event"
            readonly clearable
            hide-details
            required
            ></v-text-field>
            <v-date-picker v-model="filterListByTab[tab].from_dt" scrollable
            first-day-of-week="1"
            >
            <v-spacer></v-spacer>
            <v-btn flat @click="dlgFromDate = false">Cancel</v-btn>
            <v-btn flat color="accent" @click="$refs.dlgFromDate.save(filterListByTab[tab].from_dt)">OK</v-btn>
          </v-date-picker>
        </v-dialog>
      </v-flex>
      <v-flex xs6>
        <v-dialog ref="dlgToDate"
        persistent v-model="dlgToDate"
        lazy max-width="290px"
        :return-value.sync="filterListByTab[tab].end_dt"
        >
        <v-text-field
        slot="activator" label="Due till"
        v-model="filterListByTab[tab].end_dt"
        append-icon="event"
        readonly clearable
        hide-details
        required
        ></v-text-field>
        <v-date-picker v-model="filterListByTab[tab].end_dt" scrollable
        first-day-of-week="1"
        >
        <v-spacer></v-spacer>
        <v-btn flat @click="dlgToDate = false">Cancel</v-btn>
        <v-btn flat color="accent" @click="$refs.dlgToDate.save(filterListByTab[tab].end_dt)">OK</v-btn>
      </v-date-picker>
    </v-dialog>
  </v-flex>
</v-layout>
</v-container>
</v-card-text>
<v-card-actions>
  <v-btn flat @click.stop="showFilter = false">Close</v-btn>
  <v-spacer></v-spacer>
  <v-btn flat @click="clearFilter">Clear all</v-btn>
  <v-btn class="ma-0" flat color="accent" @click="applyFilter">Apply</v-btn>
</v-card-actions>
</v-card>
</v-bottom-sheet>

<v-btn v-if="lAction === 'view'"
:style="'position:fixed; ' + ($vuetify.breakpoint.smAndDown?'bottom:15px; right:15px;':'bottom:15px; right:15px;')"
dark fab fixed
color="accent"
@click.native="prepareCreate()">
<v-icon>add</v-icon>
</v-btn>

<!-- filter btn -->
<v-btn small
:style="'position:fixed; ' + ($vuetify.breakpoint.smAndDown?'bottom:15px; left:25px;':'bottom:15px; left:315px;')"
dark fab fixed v-if="lAction === 'view'"
color="accent"
@click.native="prepareFilter()">
<v-badge overlap color="info">
  <template v-slot:badge v-if="enabledFilter[this.tab]">
    <v-icon class="caption">done</v-icon>
  </template>
  <v-icon class="pa-2">filter_list</v-icon>
</v-badge>
</v-btn>

</v-layout>

<!-- snack bar for reporting -->
<v-snackbar :color="sbarCol" v-model="sbar"
:timeout="2000" multi-line><span class="mx-auto">{{ sbarMsg }}</span>
</v-snackbar>
</v-container>
</template>

<script>
import config from '@/config/app-cfg'
import handy from '@/utils/handy'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import Vue from 'vue'
Vue.use(Viewer)

export default {
  data () {
    return {
      // common
      sbar: false,
      sbarCol: 'error',
      sbarMsg: '',
      handy: handy,
      config: config,
      rules: handy.rules,
      calFab: false,
      // create ticket
      lAction: '',
      tabItems: ['All Open', 'All Closed'],
      tab: 'tab-0',
      lSupport: {},
      departmentList: [],
      catList: [],
      subCatList: [],
      assignUserList: [],
      planStartDt: false,
      planEndDt: false,
      actStartDt: false,
      actEndDt: false,
      jobDoneDt: false,
      beingSaved: false,
      openTickets: [],
      closedTickets: [],
      ticketHead: [
        { text: 'Ticket No', value: 'ticket_id', class: 'pa-2' },
        { text: 'Created Date', value: 'created_dt', class: 'pa-2' },
        { text: 'Department', value: 'dept_name', class: 'pa-2' },
        { text: 'Category', value: 'cat', class: 'pa-2' },
        { text: 'Description', value: 'description', class: 'pa-2 text-xs-center' },
        { text: 'Created By', value: 'cust_name', class: 'pa-2' },
        { text: 'Assigned to', value: 'assigned_to', class: 'pa-2' },
        { text: 'Priority', value: 'priority', class: 'pa-2' },
        { text: 'Status', value: 'status', class: 'pa-2' },
        { text: 'Attach', sortable: false, value: 'attach' },
        { text: '', sortable: false, value: 'action' }
      ],
      choosenView: 'card',
      enabledFilter: [],
      filterListByTab: [],
      filterStatus: ['New', 'In Progress', 'Need More Info.', 'On-Hold', 'Cancelled', 'Job-Done', 'Completed', 'Reopen'],
      dlgFromDate: false,
      dlgToDate: false,
      showFilter: false,
      mcList: [],
      statusList: ['Need More Info.', 'On-Hold', 'Completed', 'Reopen', 'Cancelled'],
      lTicketStatus: [],
      placeHolder: '',
      showDlgStatus: false,
      lTimeLine: [],
      showTimeline: false,
      previousData: [],
      dlgEndDate: false,
      priorityList: [],
      options: {
        toolbar: true,
        url: 'data-source'
      },
      ticketLists: []
    }
  },
  created () {
    for (var i = 0; i < this.tabItems.length; i++) {
      this.enabledFilter['tab-' + i] = false
      this.filterListByTab['tab-' + i] = this.getEmptyFilter()
    }
  },
  computed: {
    today: function () {
      return handy.formatDBDate(Date())
    }
  },
  mounted () {
    var curDate = new Date()
    this.lSupport.planned_start_dt = handy.formatDBDate(curDate)
    this.loadTickets()
    this.lAction = 'view'
  },
  methods: {
    msg (m, type = 0) {
      if (type === 0) {
        this.sbarCol = 'error'
      } else if (type === 1) {
        this.sbarCol = 'success'
      } else {
        this.sbarCol = 'info'
      }
      this.sbar = true
      this.sbarMsg = m
    },
    getEmptyTickets () {
      var emptyTicket = {
        dep_pair: '',
        cat_pair: '',
        sub_cat_pair: '',
        description: '',
        planned_start_dt: this.lSupport.planned_start_dt,
        end_dt: null,
        priority_pair: {
          priority_id: 1,
          priority: 'Normal'
        },
        status: 'New',
        assigned_to_pair: {},
        others: '',
        comm_id: config.COMM_ID,
        created_by: config.USER_ID
      }
      return emptyTicket
    },
    prepareCreate () {
      this.lSupport = this.getEmptyTickets()
      this.lAction = 'Create'
      this.loadDepartments()
      this.loadAssignUserList()
      this.loadPriorityList()
    },
    loadDepartments () {
      var qry = {
        params: {
          vendor_id: config.FM_VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getDepartmentsList/', qry)
      .then(response => {
        this.departmentList = response.data
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.departmentList = []
      })
    },
    loadCategories (curDept) {
      var qry = {
        params: {
          dept_id: curDept.dept_id,
          vendor_id: config.FM_VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getCategoriesBasedOnDeptId/', qry)
      .then(response => {
        this.catList = response.data
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.catList = []
      })
    },
    loadSubCatList (curCat) {
      var qry = {
        params: {
          cat_id: curCat.cat_id
        }
      }
      this.axios.get(config.API_URL + '/getSubCatBasedOnCatId/', qry)
      .then(response => {
        this.subCatList = response.data
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.subCatList = []
      })
    },
    loadPriorityList () {
      var qry = {
        params: {
          vendor_id: config.FM_VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getPriorityList/', qry)
      .then(response => {
        this.priorityList = response.data
      })
      .catch(err => {
        this.msg(err)
        this.priorityList = []
      })
    },
    loadAssignUserList () {
      var qry = {
        params: {
          vendor_id: config.FM_VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getBackOfficeStaffs/', qry)
      .then(response => {
        this.assignUserList = response.data
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.assignUserList = []
      })
    },
    cancelChanges () {
      this.lAction = 'view'
    },
    saveTicket (action) {
      if (!this.$refs.sForm.validate()) {
        return
      }
      if (!this.lSupport.planned_start_dt) {
        this.msg('Please select planned start date', 0)
      }
      if (action === 'Create' || action === 'Update') {
        this.lSupport.notes = ''
      }
      if (action === 'Update') {
        if (this.previousData.cat_pair.cat_id !== this.lSupport.cat_pair.cat_id) {
          this.lSupport.notes += ' Category changed to "' + this.lSupport.cat_pair.cat + '",'
        }
        if (this.previousData.sub_cat_pair.sub_cat_id !== this.lSupport.sub_cat_pair.sub_cat_id) {
          this.lSupport.notes += ' Sub category changed to "' + this.lSupport.sub_cat_pair.sub_cat + '",'
        }
        if (this.previousData.description !== this.lSupport.description) {
          this.lSupport.notes += ' Description from "' + this.previousData.description + '" to "' + this.lSupport.description + '",'
        }
        if (this.previousData.planned_start_dt !== this.lSupport.planned_start_dt) {
          this.lSupport.notes += ' Start date changed to "' + this.lSupport.planned_start_dt + '",'
        }
        if (this.previousData.planned_end_dt !== this.lSupport.planned_end_dt) {
          this.lSupport.notes += ' End date changed to "' + this.lSupport.planned_end_dt + '",'
        }
        if (this.previousData.status !== this.lSupport.status) {
          this.lSupport.notes += ' Status changed to "' + this.lSupport.status + '",'
        }
        if (this.previousData.priority !== this.lSupport.priority) {
          this.lSupport.notes += ' Priority changed to "' + this.lSupport.priority + '"'
        }
      }
      if (!this.lSupport.files) {
        this.lSupport.files = []
      }
      this.lSupport.dept_id = this.lSupport.dep_pair.dept_id
      this.lSupport.cat_id = this.lSupport.cat_pair.cat_id
      this.lSupport.sub_cat_id = this.lSupport.sub_cat_pair.sub_cat_id ? this.lSupport.sub_cat_pair.sub_cat_id : null
      this.lSupport.priority_id = this.lSupport.priority_pair.priority_id
      this.lSupport.vendor_id = config.FM_VENDOR_ID
      this.lSupport.updated_by = config.USER_ID
      this.lSupport.assigned_to = this.lSupport.assigned_to_pair.emp_id ? this.lSupport.assigned_to_pair.emp_id : null
      this.lSupport.is_sv_user = false
      this.lSupport.is_updated_by_sv_user = false
      this.lSupport.is_action_by_sv_user = false
      this.beignSaved = true
      this.axios.post(config.API_URL + '/backOfficeSupport/' + action, this.lSupport)
      .then(response => {
        this.lAction = 'view'
        this.loadTickets()
        this.loadTicketAttachment(this.lSupport.ticket_id)
        this.beingSaved = false
      })
      .catch(err => {
        this.msg(err.response.data)
        this.beingSaved = false
      })
    },
    loadTickets () {
      var qry = {
        params: {
          vendor_id: config.FM_VENDOR_ID,
          comm_id: config.COMM_ID,
          filter: this.filterListByTab[this.tab]
        }
      }
      this.axios.get(config.API_URL + '/getTicketsList/', qry)
      .then(response => {
        this.ticketLists = response.data
        this.openTickets = response.data.filter(rec => rec.status !== 'Completed' && rec.status !== 'Cancelled')
        this.closedTickets = response.data.filter(rec => rec.status === 'Completed' || rec.status === 'Cancelled')
      })
      .catch(err => {
        this.msg(err)
        this.ticketLists = []
      })
    },
    prepareUpdate (curTicket) {
      this.lSupport = Object.assign({}, curTicket)
      this.lSupport.action_by = config.USER_ID
      this.lSupport.dep_pair = { dept_id: this.lSupport.dept_id, dept_name: this.lSupport.dept_name }
      this.lSupport.cat_pair = { cat_id: this.lSupport.cat_id, cat: this.lSupport.cat }
      this.lSupport.sub_cat_pair = { sub_cat_id: this.lSupport.sub_cat_id, sub_cat: this.lSupport.sub_cat }
      this.lSupport.planned_start_dt = this.lSupport.planned_start_dt ? handy.formatDBDate(this.lSupport.planned_start_dt) : null
      this.lSupport.planned_end_dt = this.lSupport.planned_end_dt ? handy.formatDBDate(this.lSupport.planned_end_dt) : null
      this.lSupport.act_start_dt = this.lSupport.act_start_dt ? handy.formatDBDateTime(this.lSupport.act_start_dt) : null
      this.lSupport.act_end_dt = this.lSupport.act_end_dt ? handy.formatDBDateTime(this.lSupport.act_end_dt) : null
      this.lSupport.job_done_dt = this.lSupport.job_done_dt ? handy.formatDBDateTime(this.lSupport.job_done_dt) : null
      this.lSupport.assigned_to_pair = { emp_id: curTicket.emp_id, emp_name_with_id: curTicket.emp_name_with_id }
      this.previousData = Object.assign({}, this.lSupport)
      this.lSupport.priority_pair = { priority_id: this.lSupport.priority_id, priority: this.lSupport.priority }
      this.lSupport.assign_comments = ''
      this.loadTicketAttachment(curTicket.ticket_id)
      this.lAction = 'Update'
      this.loadDepartments(curTicket)
      this.loadCategories(curTicket)
      this.loadSubCatList(curTicket)
      this.loadAssignUserList(curTicket)
      this.loadPriorityList()
    },
    deleteTicket (curTicket) {
      if (!confirm('Sure, you want to delete the ticket ?')) {
        return
      }
      // up in db
      this.beingSaved = true
      this.axios.post(config.API_URL + '/backOfficeSupport/delete', curTicket)
      .then(response => {
        // refresh the list
        var idx = this.ticketLists.findIndex(ticket => ticket.ticket_id === curTicket.ticket_id)
        this.ticketLists.splice(idx, 1)
        this.lAction = 'view'
        this.loadTickets()
        this.beingSaved = false
      })
      .catch(err => {
        this.msg(err.response.data)
        this.beingSaved = false
      })
    },
    changeView (curView) {
      this.choosenView = curView
    },
    prepareTicketStatus (curTicket, curStatus) {
      this.lTicketStatus = Object.assign({}, curTicket)
      this.lTicketStatus.action = curStatus
      this.lTicketStatus.notes = ''
      this.lTicketStatus.sub_action = 'create'
      if (curStatus === 'Comment') {
        this.placeHolder = 'Type your comment here...'
      } else if (curStatus === 'Need More Info.') {
        this.placeHolder = 'From whom you are looking for information..'
        this.lTicketStatus.act_start_dt = this.lTicketStatus.act_start_dt ? handy.formatDBDate(this.lTicketStatus.act_start_dt) : null
      } else if (curStatus === 'On-Hold') {
        this.placeHolder = 'Type your reason for On-hold...'
        this.lTicketStatus.act_start_dt = this.lTicketStatus.act_start_dt ? handy.formatDBDate(this.lTicketStatus.act_start_dt) : null
      } else if (curStatus === 'Completed') {
        this.lTicketStatus.planned_end_dt = this.today
        this.placeHolder = 'Type your resolution here...'
        this.lTicketStatus.end_dt = this.today
      }
      if (curStatus === 'On-Hold' || curStatus === 'Need More Info.' || curStatus === 'Completed' || curStatus === 'Cancelled' || curStatus === 'Reopen' || curStatus === 'Comment') {
        this.showDlgStatus = true
      }
      this.$forceUpdate()
    },
    postTicketStatus () {
      if (this.lTicketStatus.notes) {
        this.lTicketStatus.action_by = config.USER_ID
        this.lTicketStatus.vendor_id = config.FM_VENDOR_ID
        this.lTicketStatus.is_action_by_sv_user = false
        this.axios.post(config.API_URL + '/backOfficeSupport/status', this.lTicketStatus)
        .then(response => {
          this.loadTickets()
          this.showDlgStatus = false
        })
        .catch(err => {
          this.msg(err, 0)
        })
      } else {
        this.msg('Please enter your comments', 0)
      }
    },
    loadTimeLine (curTicket) {
      var qry = {
        params: {
          ticket_id: curTicket
        }
      }
      this.axios.get(config.API_URL + '/getTimelineDetailsByTicketId/', qry)
      .then(response => {
        this.lTimeLine = response.data
        var timeLineNote = []
        timeLineNote = response.data.filter(rec => rec.action === 'Ticket Updated' && rec.notes !== null)
        if (timeLineNote) {
          var note = ''
          var cidx = 0
          for (var k = 0; k < timeLineNote.length; k++) {
            cidx = response.data.findIndex(rec => rec.ticket_det_id === timeLineNote[k].ticket_det_id)
            note = timeLineNote[k].notes.split(',')
            this.lTimeLine[cidx].timeLineNote = []
            for (var i = 0; i < note.length; i++) {
              this.lTimeLine[cidx].timeLineNote[i] = note[i]
            }
          }
        }
        this.loadTicketAttachment(curTicket)
        this.showTimeline = true
        setTimeout(() => {
          var tmpItem = document.getElementById('timeline_' + (this.lTimeLine.length - 1))
          tmpItem.scrollIntoView()
        }, 100)
      })
      .catch(err => {
        this.msg(err, 0)
        this.lTimeLine = []
        this.showTimeline = false
      })
    },
    loadCreatedList () {
      var qry = {
        params: {
          comm_id_list: config.COMM_ID,
          vendor_id: config.FM_VENDOR_ID
        }
      }
      this.mcList = []
      this.axios.get(config.API_URL + '/getEligibleAssigneeForComplaints/', qry)
      .then(response => {
        response.data.forEach(rec => {
          this.mcList.push({user_id: rec.user_id, user_name: handy.startWithUpper(rec.cust_name), is_sv_user: rec.is_sv_user})
        })
      })
    },
    getEmptyFilter () {
      var filter = {
        from_dt: null,
        end_dt: null,
        created_user_pair_list: [],
        assigned_user_pair_list: [],
        ticket_cat_list: [],
        ticket_dept_list: [],
        priority_list: [],
        ticket_status_list: []
      }
      return filter
    },
    prepareFilter () {
      this.showFilter = true
      this.loadCreatedList()
      this.loadDepartments()
      this.loadAssignUserList()
      this.loadPriorityList()
    },
    applyFilter () {
      if (this.filterListByTab[this.tab].from_dt > this.filterListByTab[this.tab].end_dt) {
        this.msg('to date should be greater than from date')
      } else {
        if (!this.filterListByTab[this.tab].from_dt && this.filterListByTab[this.tab].end_dt) {
          this.filterListByTab[this.tab].from_dt = this.filterListByTab[this.tab].end_dt
        } else if (this.filterListByTab[this.tab].from_dt && !this.filterListByTab[this.tab].end_dt) {
          this.filterListByTab[this.tab].end_dt = this.filterListByTab[this.tab].from_dt
        }
        if (this.filterListByTab[this.tab].assigned_user_pair_list.emp_id || this.filterListByTab[this.tab].created_user_pair_list.user_id || this.filterListByTab[this.tab].priority_list.length || this.filterListByTab[this.tab].ticket_cat_list.length || this.filterListByTab[this.tab].ticket_status_list.length || this.filterListByTab[this.tab].ticket_dept_list.dept_id || this.filterListByTab[this.tab].from_dt || this.filterListByTab[this.tab].end_dt) {
          this.enabledFilter[this.tab] = true
        }
        this.loadTickets()
        this.showFilter = false
        this.$forceUpdate()
      }
    },
    clearFilter () {
      this.filterListByTab[this.tab].from_dt = null
      this.filterListByTab[this.tab].end_dt = null
      this.filterListByTab[this.tab].created_user_pair_list = []
      this.filterListByTab[this.tab].assigned_user_pair_list = []
      this.filterListByTab[this.tab].ticket_dept_list = []
      this.filterListByTab[this.tab].ticket_cat_list = []
      this.filterListByTab[this.tab].ticket_status_list = []
      this.filterListByTab[this.tab].priority_list = []
      this.enabledFilter[this.tab] = false
      this.showFilter = false
      this.loadTickets()
      this.$forceUpdate()
    },
    pickFile () {
      if (this.lAction === 'Update' || this.lAction === 'Create') {
        this.$refs.fileInput.click()
      } else {
        this.$refs.statusFileInput.click()
      }
    },
    loadFilesFromFileBrowser (curTicket) {
      const files = event.target.files
      if (!curTicket.files) {
        curTicket.files = []
      }
      Array.from(files).forEach((file) => {
        let currentDate = new Date()
        let time = currentDate.getHours() + '-' + currentDate.getMinutes() + '-' + currentDate.getSeconds()
        const fileReader = new FileReader()
        const getResult = new Promise(resolve => {
          fileReader.onload = e => {
            curTicket.files.push({
              file_url: e.target.result.split(',')[1],
              file_name: file.name.split('.')[0] + '_' + handy.formatDBDate(currentDate) + '_' + time + '.' + file.name.split('.')[1],
              is_selected: true,
              is_changed: true
            })
            this.$forceUpdate()
          }
        })
        fileReader.readAsDataURL(file)
        return getResult.then(file => {
          return file
        })
      })
    },
    loadTicketAttachment (curTicket, curTicketDet) {
      var path = require('path')
      var qry = {
        params: {
          ticket_id: curTicket
        }
      }
      this.lTimeLine.fileUrls = {}
      this.axios.get(config.API_URL + '/getAttachmentByTicketId/', qry)
      .then(response => {
        this.lTimeLine.fileUrls = response.data
        // make notes if they have done any change while updating the ticket
        var fileUrls = this.lTimeLine.fileUrls.filter(rec => rec.action === 'Ticket Created' || rec.action === 'Ticket Updated')
        if (fileUrls.length > 0) {
          this.lSupport.files = []
          fileUrls.forEach((rec) => {
            this.lSupport.files.push({
              extension: rec.file_url.split('.')[1],
              file_url: rec.file_url,
              file_name: rec.file_url ? path.basename(rec.file_url) : '',
              is_selected: true,
              is_changed: false,
              action: rec.action,
              ticket_det_id: rec.ticket_det_id,
              ticket_id: rec.ticket_id
            })
          })
        }
        this.lTimeLine.attachImages = []
        this.lTimeLine.attachFile = []
        this.lTimeLine.fileUrls.forEach(rec => {
          rec.extension = rec.file_url.split('.')[1]
          if (rec.extension.toLowerCase() === 'png' || rec.extension.toLowerCase() === 'jpg' || rec.extension.toLowerCase() === 'gif') {
            this.lTimeLine.attachImages.push({
              extension: rec.file_url.split('.')[1],
              file_url: rec.file_url,
              file_name: rec.file_url ? path.basename(rec.file_url) : '',
              is_selected: true,
              is_changed: false,
              action: rec.action,
              ticket_det_id: rec.ticket_det_id,
              ticket_id: rec.ticket_id
            })
          } else {
            this.lTimeLine.attachFile.push({
              extension: rec.file_url.split('.')[1],
              file_url: rec.file_url,
              file_name: rec.file_url ? path.basename(rec.file_url) : '',
              is_selected: true,
              is_changed: false,
              action: rec.action,
              ticket_det_id: rec.ticket_det_id,
              ticket_id: rec.ticket_id
            })
          }
        })
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err, true)
        this.lTimeLine.fileUrls = []
      })
    },
    loadFilesFromBrowser (curTicket) {
      const files = event.target.files
      if (!curTicket.files) {
        curTicket.files = []
      }
      Array.from(files).forEach((file) => {
        const fileReader = new FileReader()
        const getResult = new Promise(resolve => {
          fileReader.onload = e => {
            curTicket.files.push({
              file_url: e.target.result.split(',')[1],
              file_name: file.name,
              is_selected: true,
              is_changed: true
            })
            this.$forceUpdate()
          }
        })
        fileReader.readAsDataURL(file)
        return getResult.then(file => {
          return file
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// BackOfficeSup.vue?203236c5